import { logEvent } from "firebase/analytics"
import mixpanel, { Dict } from "mixpanel-browser"
import { AnalyticsEvents } from "../../types/Analytics"
import { isExcludedEmail } from "../../utils/email"
import { isProduction } from "../../utils/general"
import { analytics } from "../App"
import { useAppContext } from "../Context"

export const useMixpanel = () => {
  const { user } = useAppContext()

  const logAnalyticsEvent = (
    eventName: AnalyticsEvents,
    eventProperties?: Dict,
  ) => {
    if (isProduction && !isExcludedEmail(user?.email || "")) {
      mixpanel.track(eventName, eventProperties)
      logEvent(analytics, eventName, eventProperties)
    }
  }

  return { logAnalyticsEvent }
}
